import { PaymentMethodsAddAchFormStripe } from '../../../components/payment-methods/add-ach/add-ach-form-stripe';
import { ContextToProps } from '../context-to-props';

export const PaymentMethodsDefaultAchForm = () => {
  return (
    <ContextToProps.AchForm
      stripeComponent={PaymentMethodsAddAchFormStripe}
      justifiComponent={() => {
        console.warn('Justifi ACH form is not supported yet');
        return <></>;
      }}
    />
  );
};
